:host {
  /** @prop --vertical-grid-gap: vertical grid gap. only relevant if a grid-row has content overflowing into the next row */
  --vertical-grid-gap: var(--wb-spacing-3xs);

  display: grid;
  grid-template-columns: repeat(var(--wb-grid-column-amount), 1fr);
  grid-gap: var(--vertical-grid-gap) var(--wb-grid-gutter-width);
}
